<template>
  <div class="billing-toggle">
    <div class="billing-toggle__track">
      <button
        class="billing-toggle__btn"
        :class="{ 'billing-toggle__btn--active': billingPeriod === 'monthly' }"
        @click="setPeriod('monthly')"
      >
        Mensual
      </button>
      <button
        class="billing-toggle__btn"
        :class="{ 'billing-toggle__btn--active': billingPeriod === 'annual' }"
        @click="setPeriod('annual')"
      >
        Anual
      </button>
      <span v-if="billingPeriod === 'annual'" class="billing-toggle__badge">
        Ahorra un 10%
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BillingToggle",
  computed: {
    billingPeriod() {
      return this.$store.getters.billingPeriod;
    }
  },
  methods: {
    setPeriod(period) {
      this.$store.dispatch("setBillingPeriod", period);
    }
  }
};
</script>

<style lang="scss" scoped>
.billing-toggle {
  display: inline-flex;
  align-items: center;

  &__track {
    display: inline-flex;
    align-items: center;
    background: #e8ecf1;
    border-radius: 10px;
    padding: 3px;
  }

  &__btn {
    padding: 9px 22px;
    font-size: 13px;
    font-weight: 500;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    background: transparent;
    color: #888780;
    transition: all 0.2s;
    font-family: "Plus Jakarta Sans", sans-serif;

    &--active {
      background: #fff;
      color: #2d2b55;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }
  }

  &__badge {
    font-size: 12px;
    color: #1d9e75;
    font-weight: 600;
    margin-left: 10px;
    margin-right: 6px;
    white-space: nowrap;
  }
}
</style>
